export function getChannel(entity) {
  return `${entity.type}-${entity._id}`;
}

export function getForumChannel() {
  return 'forum';
}
